import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Chip,
  Divider,
  Stack,
  Typography
} from '@mui/material'

import { CustomerEntry, OneTimeReminderInfoViaEnum } from '../../sdk'
import { ReminderContent } from './ReminderContent'
import {
  ReminderTimeType,
  reminderTimeTypeDescription,
  SelectReminderTime
} from './SelectReminderTime'
import { SelectReminderVia } from './SelectReminderVia'

export type AppointmentReminderFieldsType = {
  vias: OneTimeReminderInfoViaEnum[]
  title: string
  message: string
  scheduledDateTimes: ReminderTimeType[]
  customDateTime: Date
}
export const AppointmentReminderFields = ({
  appointmentReminderFields,
  setAppointmentReminderFields,
  appointmentTime,
  customer
}: {
  appointmentReminderFields: AppointmentReminderFieldsType
  setAppointmentReminderFields: React.Dispatch<
    React.SetStateAction<AppointmentReminderFieldsType>
  >
  appointmentTime: Date
  customer: CustomerEntry | undefined
}) => {
  return (
    <Accordion disableGutters>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{ bgcolor: 'primary.light' }}>
        <Stack>
          <Typography variant="subtitle1">Reminder</Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap'
            }}>
            {appointmentReminderFields.scheduledDateTimes.length === 0 ||
            appointmentReminderFields.vias.length === 0 ? (
              <Chip label="No reminders set" sx={{ mr: 1, mt: 1 }} />
            ) : (
              appointmentReminderFields.scheduledDateTimes.map((time) => {
                return time === 'custom' ? (
                  <Chip
                    key={time}
                    label={appointmentReminderFields.customDateTime.toLocaleString()}
                    sx={{ mr: 1, mt: 1 }}
                  />
                ) : (
                  <Chip
                    key={time}
                    label={reminderTimeTypeDescription[time]}
                    sx={{ mr: 1, mt: 1 }}
                  />
                )
              })
            )}
          </Box>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Stack spacing={1}>
          <SelectReminderTime
            scheduledDateTimes={appointmentReminderFields.scheduledDateTimes}
            setScheduledDateTimes={(newValue) =>
              setAppointmentReminderFields((prev) => ({
                ...prev,
                scheduledDateTimes: newValue
              }))
            }
            customDateTime={appointmentReminderFields.customDateTime}
            setCustomDateTime={(newValue) =>
              setAppointmentReminderFields((prev) => ({
                ...prev,
                customDateTime: newValue
              }))
            }
            appointmentTime={appointmentTime}
          />
          <Divider />
          <Typography>Send Reminders:</Typography>
          <SelectReminderVia
            vias={appointmentReminderFields.vias}
            setVias={(newValue) =>
              setAppointmentReminderFields((prev) => ({
                ...prev,
                vias: newValue
              }))
            }
            customer={customer}
          />
          <Divider />
          <ReminderContent
            vias={appointmentReminderFields.vias}
            title={appointmentReminderFields.title}
            setTitle={(newValue) =>
              setAppointmentReminderFields((prev) => ({
                ...prev,
                title: newValue
              }))
            }
            message={appointmentReminderFields.message}
            setMessage={(newValue) =>
              setAppointmentReminderFields((prev) => ({
                ...prev,
                message: newValue
              }))
            }
          />
        </Stack>
      </AccordionDetails>
    </Accordion>
  )
}
